import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminCheckbox from "components/admin/checkbox"
import AppHistory from "shared/history"
import {ContactEmail} from "models"
import {ContactsSelectWithContainer} from "components/contacts/select"
import env from "shared/env"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import {Form} from "@kaspernj/api-maker/build/form"
import memo from "set-state-compare/build/memo"
import React from "react"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"
import UtilsButton from "components/utils/button"
import UtilsInput from "components/utils/input"
import {v4 as uuidv4} from "uuid"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminContactEmailsEdit extends ShapeComponent {
  setup() {
    setLayout("admin")

    const {t} = useI18n({namespace: "js.routes.admin.contact_emails.edit"})
    const params = useParams()
    const {contactEmail, contactEmailId} = useModel(ContactEmail, {
      match: {params},
      newIfNoId: {
        defaults: () => ({id: uuidv4()})
      },
      select: {
        ContactEmail: ["contactId", "email", "id"]
      }
    })

    this.setInstance({
      contactEmail,
      contactEmailId,
      t
    })
    this.useStates({
      form: null
    })

    useAdminLayout()?.setState({active: "contacts", headerTitle: this.headerTitle()})
  }

  render() {
    const {contactEmail, onSubmit, t} = this.tt

    return (
      <View dataSet={this.rootViewDataSet ||= {route: "admin--contact-emails--edit"}}>
        {contactEmail &&
          <Form onSubmit={onSubmit} setForm={this.setStates.form}>
            <View style={this.contactViewStyle ||= {marginBottom: 15}}>
              <ContactsSelectWithContainer
                attribute="contactId"
                defaultValues={contactEmail?.contactId() ? [contactEmail.contactId()] : null}
                id="contact_email_contact_id"
                label={ContactEmail.humanAttributeName("contact")}
                model={contactEmail}
                name="contact_email[contact_id]"
              />
            </View>
            <UtilsInput
              dataSet={this.emailInputDataSet ||= {class: "contact-email-email-input"}}
              defaultValue={contactEmail?.email() || ""}
              label={ContactEmail.humanAttributeName("email")}
              name="contact_email[email]"
              style={this.emailInputStyle ||= {marginBottom: 15}}
            />
            <AdminCheckbox
              attribute="primary"
              dataSet={this.primaryCheckBoxDataSet ||= {class: "contact-email-primary"}}
              label={ContactEmail.humanAttributeName("primary")}
              model={contactEmail}
              name="contact_email[primary]"
              style={this.primaryCheckBoxStyle ||= {marginBottom: 15}}
            />
            <UtilsButton dataSet={this.saveEmailButtonDataSet ||= {class: "save-email-button"}} primary submit title={t("js.shared.save")} />
          </Form>
        }
      </View>
    )
  }

  headerTitle() {
    const {contactEmail, t} = this.tt

    if (contactEmail?.isNewRecord()) {
      return t(".add_new_contact_email")
    } else if (contactEmail?.isPersisted()) {
      return t(".edit_contact_email")
    }
  }

  onSubmit = async () => {
    const formData = this.s.form.asObject()
    const {contactEmail, t} = this.tt

    if (contactEmail.isNewRecord()) {
      formData.contact_email.new_id = contactEmail.id()
    }

    try {
      await contactEmail.saveRaw(formData)
      FlashMessage.success(t(".the_contact_email_was_saved"))

      setTimeout(() => {
        AppHistory.push(Routes.adminContactEmailsPath(contactEmail.contactId()))
      }, env.RAILS_ENV == "test" ? 500 : 0) // Fix race condition in test env
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}))
